module.exports = __webpack_public_path__ + "img/Tanzania.09d6369c.svg";